/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useCallback, useMemo} from 'react'
import {CloudPageTitle} from '../../../../_metronic/layout/core/CloudPageData'
import {Helmet} from 'react-helmet'
import Searchbar from 'app/components/Searchbar'
import EmptyState from 'app/components/EmptyState'
import ReactPaginate from 'react-paginate'
import securityChecksData from '../services/SecuirtyChecks.json'
interface UserData {
  code: string
  title: string
  description: string
  compliance: 'compliant' | 'non-compliant' | 'disabled'
}
interface SecurityRule {
  code: string
  title: string
  description: string
  compliance: 'compliant' | 'non-compliant' | 'disabled'
}

const Checks: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredItems, setFilteredItems] = useState<UserData[]>([])
  const [selectedProvider, setSelectedProvider] = useState<string>('')
  const [currentPage, setCurrentPage] = useState(0)
  const [selectedNumber, setSelectedNumber] = useState('50')

  const securityRules: SecurityRule[] = useMemo(() => securityChecksData as SecurityRule[], [])

  const filterItems = useCallback(() => {
    const term = searchTerm.toLowerCase();
    if (term === '') {
      if (selectedProvider === '') {
        setFilteredItems(securityRules as unknown as UserData[]);
      } else {
        const filtered = securityRules.filter((rule) =>
          rule.code.toLowerCase().startsWith(selectedProvider.toLowerCase())
        );
        setFilteredItems(filtered as unknown as UserData[]);
      }
    } else {
      const filtered = securityRules.filter((rule) => {
        const matchesProvider =
          selectedProvider === '' ||
          rule.code.toLowerCase().startsWith(selectedProvider.toLowerCase());
        const matchesSearch = rule.title.toLowerCase().includes(term);
        return matchesProvider && matchesSearch;
      });
      setFilteredItems(filtered as unknown as UserData[]);
    }
  }, [searchTerm, selectedProvider, securityRules]);

  useEffect(() => {
    filterItems();
  }, [filterItems]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(0);
  }, [searchTerm, selectedProvider]);

  const handleProviderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProvider(e.target.value.toLowerCase())
  }

  // Pagination logic
  const itemsPerPage = parseInt(selectedNumber)
  const pageCount = Math.ceil(filteredItems.length / itemsPerPage)
  const startIndex = currentPage * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentItems = filteredItems.slice(startIndex, endIndex)

  const handlePageClick = (event: {selected: number}) => {
    setCurrentPage(event.selected)
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Clouds</title>
      </Helmet>
      <CloudPageTitle
        icon='Cloud.svg'
        title='Clouds'
        desc={`${securityRules.length} security checks`}
        // breadcrumbs={usersBreadcrumbs}
      >
        Clouds
      </CloudPageTitle>

      <div className='card card-custom '>
        <div className='card-header border-0 pt-6 h-100'>
          <div className='card-title'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          <div className='card-toolbar'>
            <div className='d-flex align-items-center justify-content-end'>
              <span className='fs-6 fw-semibold mx-4'>Provider:</span>
              <select
                id='cloudProvider'
                className='form-select me-4'
                aria-label='Select Cloud Provider'
                value={selectedProvider}
                style={{width: '70%', height: '40px'}}
                onChange={handleProviderChange}
              >
                <option value=''>All</option>
                <option value='aws'>AWS</option>
                <option value='gcp'>GCP</option>
                <option value='azure'>Azure</option>
                <option value='do'>DigitalOcean</option>
              </select>
            </div>
          </div>
        </div>

        <div className='card-body py-3 '>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold fs-7 border-bottom border-dotted' style={{color: '#5A5A5A'}}>
                  <th className='ps-4 min-w-100px rounded-start'>RULE CODE</th>
                  <th className='min-w-300px'>TITLE</th>
                  <th className='min-w-500px'>DESCRIPTION</th>
                  {/* <th className='min-w-150px'>COMPLIANCE</th> */}
                </tr>
              </thead>

              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((rule, index) => (
                    <tr key={rule.code} className='border-bottom border-dotted'>
                      <td>
                        <div className='d-flex align-items-center mx-5'>{rule.code}</div>
                      </td>
                      <td>
                        <div className='d-flex align-items-center'>{rule.title}</div>
                      </td>
                      <td>
                        <div className='d-flex align-items-center'>{rule.description}</div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>
                      <EmptyState
                        title='No Security Checks Found'
                        description={searchTerm 
                          ? 'No security checks found matching your search criteria.' 
                          : 'No security checks available for the selected cloud provider.'}
                        isLoading={false}
                      />
                    </td>
                  </tr>
                )}
              </tbody>

              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
          
          {/* Pagination Controls */}
          {filteredItems.length >= 15 && (
            <div className='d-flex justify-content-between'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'>
                <div>
                  <select
                    name='kt_checks_table_length'
                    aria-controls='kt_checks_table'
                    className='form-select'
                    id='dt-length-1'
                    value={selectedNumber}
                    onChange={(e) => setSelectedNumber(e.target.value)}
                  >
                    <option value='50'>50</option>
                    <option value='100'>100</option>
                    <option value='150'>150</option>
                  </select>
                </div>
              </div>

              <div className='d-flex justify-content-end my-5'>
                <ReactPaginate
                  previousLabel={'<'}
                  nextLabel={'>'}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={pageCount}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={1}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {Checks}
